import { render, staticRenderFns } from "./saleBomList.vue?vue&type=template&id=60cbd168&"
import script from "./saleBomList.vue?vue&type=script&lang=ts&"
export * from "./saleBomList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports